import React from 'react';
import Navbar from '../components/navbar/navbar';
import Footer from '../components/footer/footer';
import Galleryimages from '../components/body/galleryimages';

const Gallery = () => {
    return (
        <div>
           
            <Galleryimages/>
          
        </div>
    );
}

export default Gallery;
